/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export
export class BaseEventAdapter {
    constructor(args) {
        // Optional source identifier in case of multiple datasources
        this.sourceId = args?.sourceId;
    }

    /**
     * Get events.
     * @param {object} getEventsDto The event dto.
     * @returns void
     */
    getEvents(getEventsDto) {
        throw new Error(`Method not implemented`);
    }

    /**
     * Get a single event.
     * @param {string} eventId The event id.
     * @returns void
     */
    getEvent(eventId) {
        throw new Error(`Method not implemented`);
    }

    /**
     * Count the number of events.
     * @param {object} getEventsDto The getEvents dto.
     * @returns void
     */
    countEvents(getEventsDto) {
        throw new Error(`Method not implemented`);
    }

    /**
     * Add a new event.
     * @param {object} event The event object.
     * @returns void
     */
    addEvent(event) {
        throw new Error(`Method not implemented`);
    }

    /**
     * Update an event with new values.
     * @param {string} eventId The event id.
     * @param {object} partialEvent The event data to update.
     * @returns void
     */
    updateEvent(eventId, partialEvent) {
        throw new Error(`Method not implemented`);
    }

    /**
     * Delete a single event.
     * @param {string} eventId The event id.
     * @returns void
     */
    deleteEvent(eventId) {
        throw new Error(`Method not implemented`);
    }
}
